<template>
  <div class="page">
    <!-- 桌面端 -->
    <div class="pc-nav">
      <div class="pc-content header-content">
        <img loading="lazy" src="../assets/head/logo.png" class="logo" @click="gotoHome()" />
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="/Home">首页</el-menu-item>
          <el-submenu index="2" class="el-submenu-style">
            <template slot="title">产品服务 </template>
            <el-menu-item index="/SmartFactory" style="font-size: 1.8rem; padding: 1rem; height: 4rem">
              智慧工厂
            </el-menu-item>
            <el-menu-item index="/Robot" style="font-size: 1.8rem; padding: 1rem; height: 4rem">
              机器人
            </el-menu-item>
            <!-- <el-submenu index="3" class="ai-submenu">
              <template slot="title">AI数字人 </template>
              <el-menu-item
                index="/DigitalHuman/Mobile"
                style="font-size: 1.8rem; padding: 1rem; height: 4rem"
              >
                移动AI数字人
              </el-menu-item>
              <el-menu-item
                index="/DigitalHuman/Holography"
                style="font-size: 1.8rem; padding: 1rem; height: 4rem"
              >
                全息仓AI数字人
              </el-menu-item>
              <el-menu-item
                index="/DigitalHuman/Phone"
                style="font-size: 1.8rem; padding: 1rem; height: 4rem"
              >
                龙小伴AI数字人
              </el-menu-item>
            </el-submenu> -->
          </el-submenu>
          <el-menu-item index="/AboutUS">关于我们</el-menu-item>
          <el-menu-item index="/JoinUS">加入我们</el-menu-item>
        </el-menu>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="mobile">
      <div class="mobile-top">
        <div class="mobile-left">
          <img loading="lazy" src="../assets/head/logo.png" />
        </div>
        <div class="mobile-right" @click="navShow" :class="{ active: active }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="mobile-nav" v-show="navshow">
        <el-menu default-active="1" class="el-menu-vertical-demo" @select="handleMobileSelect">
          <el-menu-item index="/Home">首页</el-menu-item>
          <el-submenu index="2">
            <template slot="title">产品服务 </template>
            <el-menu-item index="/SmartFactory"> 智慧工厂 </el-menu-item>
            <el-menu-item index="/Robot"> 机器人 </el-menu-item>
            <!-- <el-submenu index="3">
              <template slot="title">AI数字人 </template>
              <el-menu-item index="/DigitalHuman/Mobile">
                移动AI数字人
              </el-menu-item>
              <el-menu-item index="/DigitalHuman/Holography">
                全息仓AI数字人
              </el-menu-item>
              <el-menu-item index="/DigitalHuman/Phone">
                龙小伴AI数字人
              </el-menu-item>
            </el-submenu> -->
          </el-submenu>
          <el-menu-item index="/AboutUS">关于我们</el-menu-item>
          <el-menu-item index="/JoinUS">加入我们</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "Head",
  data() {
    return {
      navshow: false,
      active: false,
      activeIndex: '/Home' // 默认激活首页
    }
  },
  created() {
    // 根据当前路由设置激活项
    this.activeIndex = this.$route.path;
  },
  methods: {
    navShow() {
      this.navshow = !this.navshow;
      this.active = !this.active;
    },
    handleSelect(key) {
      // 处理桌面端导航选择
      if (key.startsWith('/')) { // 判断是否是路由路径
        this.$router.push({ path: key });
        this.activeIndex = key;
      }
    },
    handleMobileSelect(key) {
      // 处理移动端导航选择
      if (key.startsWith('/')) { // 判断是否是路由路径
        this.$router.push({ path: key });
        this.navshow = false; // 选择后关闭移动端菜单
        this.active = false;
      }
    },
    gotoHome() {
      this.$router.push('/')
    }
  },
  watch: {
    // 监听路由变化，更新激活状态
    '$route.path'(newVal) {
      this.activeIndex = newVal;
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  background-color: rgba(255, 255, 255);

  // 桌面端样式
  .pc-nav {
    @media screen and (min-width: 769px) {
      display: block;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }

    .pc-content {
      max-width: 120rem;
      margin: 0 auto;
    }

    .header-content {
      display: flex;
      align-items: center;
      height: 6.5rem;
      width: 120rem;
      margin: 0 auto;

      .logo {
        display: inline-block;
        width: 9.6rem;
        height: 2.7rem;
        cursor: pointer;
        margin-right: 8rem;
      }

      .el-menu-demo {
        width: 100%;
        background-color: transparent;
        border-bottom: none;

        .el-menu-item {
          font-size: 1.8rem;
          margin-right: 6rem;
          height: 6.5rem;
          line-height: 6.5rem;
          color: #333;

          &:hover,
          &:focus {
            color: #0093dc;
            background-color: transparent;
          }

          &.is-active {
            color: #0093dc;
            border-bottom: 2px solid transparent;
            background-color: transparent;
          }
        }
      }
    }
  }

  // 移动端样式
  .mobile {
    @media screen and (min-width: 769px) {
      display: none;
    }

    @media screen and (max-width: 768px) {
      display: block;
    }

    .mobile-top {
      display: flex;
      align-items: center;
      width: 100vw;
      height: 7rem;
      padding: 0 2rem;
      justify-content: space-between;

      .mobile-left {
        display: flex;
        align-items: center;

        img {
          height: 2rem;
        }
      }

      .mobile-right {
        position: relative;
        padding: 1rem;
        cursor: pointer;

        span {
          display: block;
          width: 2rem;
          height: 0.3rem;
          margin-bottom: 0.3rem;
          background-color: #0093dc;
          transition: all 0.3s ease;
          border-radius: 3px;
        }

        &.active {
          span:nth-child(1) {
            transform: rotate(45deg) translate(5px, 5px);
          }

          span:nth-child(2) {
            opacity: 0;
          }

          span:nth-child(3) {
            transform: rotate(-45deg) translate(5px, -5px);
          }
        }
      }
    }

    .mobile-nav {
      position: absolute;
      left: 0;
      right: 0;
      z-index: 999;
      background-color: #eee;
      top: 7rem;
      transition: all 0.3s ease;

      .el-menu-vertical-demo {
        width: 100%;
        background-color: transparent;
        border-right: none;

        .el-menu-item,
        .el-submenu__title {
          height: 8rem;
          line-height: 8rem;
          font-size: 2rem;
          font-weight: 500;
          border-bottom: 1px solid rgba(140, 140, 140, 0.19);
          padding-left: 2.4rem;

          &:hover,
          &:focus {
            background-color: rgba(255, 255, 255, 0.5);
          }
        }

        .el-submenu .el-menu {
          background-color: rgba(255, 255, 255, 0.3);
        }

        .el-submenu .el-menu-item {
          padding-left: 4.8rem;
        }
      }
    }
  }
}
</style>

<style lang="scss">
// 单独设置该样式导航栏样式，因为导航栏不在本页面，所以不能用scoped设置
.pc-nav {
  .el-submenu-style {
    .el-submenu__title {
      padding: 0;
      margin: 0;
      font-size: 1.8rem;
      margin-right: 6rem;
      height: 6.5rem;
      line-height: 6.5rem;
      color: #333 !important;
      border-bottom: none !important;
    }
  }
}

.pc-nav .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
  color: #0093dc !important;
}

.ai-submenu {
  .el-submenu__title {
    font-size: 1.8rem !important;
    padding: 0 1rem !important;
    margin-top: 1rem;
  }
}

.mobile {
  .el-submenu__title {
    position: relative;
    color: #333;
    font-size: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue